import { render, staticRenderFns } from "./WriteMailModal.vue?vue&type=template&id=481c23a5&scoped=true&"
import script from "./WriteMailModal.vue?vue&type=script&lang=js&"
export * from "./WriteMailModal.vue?vue&type=script&lang=js&"
import style0 from "./WriteMailModal.vue?vue&type=style&index=0&id=481c23a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c23a5",
  null
  
)

export default component.exports